import React from 'react';
import PropTypes from 'prop-types';
import { getAdmins } from '../../../../utils/businessVerification';
import { List, Paragraph, TextButton } from '@zillow/constellation';

function getAdminName(admin) {
  if (admin.contactInfo.firstName) {
    const lastName = admin.contactInfo.lastName ? ` ${admin.contactInfo.lastName}` : '';
    return `${admin.contactInfo.firstName}${lastName}`;
  }
  return admin.contactInfo.email;
}

function Admin({ admin }) {
  if (!admin.contactInfo.email) {
    return null;
  }
  return (
    <List.Item>
      <TextButton as="a" href={`mailto:${admin.contactInfo.email}`}>
        {getAdminName(admin)}
      </TextButton>
    </List.Item>
  );
}

Admin.propTypes = {
  admin: PropTypes.shape({
    contactInfo: PropTypes.shape({
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  }),
};

export default function AdminContact({ data, ...props }) {
  const admins = getAdmins(data);
  if (admins.length <= 0) {
    return null;
  }

  return (
    <>
      <Paragraph {...props}>
        Contact a Company Admin if you would like to access applications or become an application manager:
      </Paragraph>
      <List>
        {admins.map((admin) => (
          <Admin key={admin.id} admin={admin} />
        ))}
      </List>
    </>
  );
}

AdminContact.propTypes = {
  data: PropTypes.object,
};
